import {
  all, call, put, takeLatest,
} from 'redux-saga/effects'
import { ReturnCall } from '../types'
import { actions as appActions } from '../state'
import { PayloadAction } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import { actions } from './EmailSettingsState'
import * as apis from './EmailSettingsApi'
import { LoginPayload } from './EmailSettingsTypes'

export function* getUserEmail() {
  yield put(appActions.isLoading(true))

  try {
    const result: ReturnCall<typeof apis.getUserEmail> = yield call(apis.getUserEmail)

    if (!result.isOk) {
      toast.error(result?.data?.data?.message || 'Falha ao buscar email!')
      return
    }

    yield put(actions.setEmail(result.data))
  } catch (error: any) {
    toast.error('Falha ao buscar email!')
  } finally {
    yield put(appActions.isLoading(false))
  }
}

export function* login(codeResponse: PayloadAction<LoginPayload>) {
  yield put(appActions.isLoading(true))

  try {
    const result: ReturnCall<typeof apis.login> = yield call(
      apis.login,
      codeResponse.payload,
    )

    if (!result.isOk) {
      toast.error(result?.data?.data?.message || 'Falha ao configurar email!')
      return
    }

    toast.success('Email configurado com sucesso!')
    yield put(actions.setEmail(result.data))
  } catch (error: any) {
    toast.error('Falha ao configurar email!')
  } finally {
    yield put(appActions.isLoading(false))
  }
}

export default function* () {
  yield all([
    takeLatest(actions.getUserEmail.type, getUserEmail),
    takeLatest(actions.login.type, login),
  ])
}
